import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {regionFields} from "../../locations/regions/regions.graphql";
import {districtFields} from "../../locations/districts/districts.graphql";
import {wardFields} from "../../locations/wards/wards.graphql";
import {streetFields} from "../../locations/streets/streets.graphql";
import { serviceCoProviderFields } from "../../instution-settings/branch-office/branch-office.graphql";
import { serviceCategoryFields } from "../../system-settings/service-category/service-category.graphql";
import { institutionFields } from "../../system-settings/institution/institution.graphql";

export const branchOfficeFields = `
id
officeUniqueId
officeName
officeCoordinates
officeRegions {
  ${regionFields}
}
officeDistrics {
  ${districtFields}
}
officeWards {
  ${wardFields}
}
officeStreets {
  ${streetFields}
}
`

export const GET_ALL_OFFICE_BRANCH = gql`
query GetAllOfficeBranch($filtering: OfficeBranchFilteringInputObject) {
  getAllOfficeBranch(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${branchOfficeFields}
    }
  }
}
`
export const ASSIGN_SERVICE_TO_OFFICE_BRANCH_MUTATION =gql`
mutation AssignServiceToOfficeBranchMutation($input: ServiceOfficeBranchInputObject) {
  assignServiceToOfficeBranchMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      service {
        id
        serviceUniqueId
        serviceIsSubService
        serviceName
        serviceIsApproved
        serviceDescription
        serviceHasSubService
        serviceHasCoProviders
        serviceCoProviders {
          ${serviceCoProviderFields}
        }
        serviceHasOpponents
        serviceGroups {
          id
          groupUniqueId
          groupType
        }
        serviceCategory {
          ${serviceCategoryFields}
        }
        serviceOpponents {
          id
          opponentUniqueId
          opponentInstitution {
            ${institutionFields}
          }
        }
        serviceResults {
          id
          resultUniqueId
          resultDescription
        }
        serviceProvider {
          id
          institutionUniqueId
          institutionName
          institutionShortform
          institutionPhysicalAddress
          institutionEmail
          institutionPostcode
          institutionWebsite
          institutionPhones
          institutionMapUrl
          institutionLogo
          institutionMinistry {
            id
            ministryUniqueId
            ministryName
          }
          institutionSector {
            id
            sectorUniqueId
            sectorName
            sectorIcon
          }
          institutionFunctions {
            id
            functionUniqueId
            functionDutyName
            functionCreateddate
            functionIsActive
          }
        }
        serviceApprovalStage {
          id
          stageUniqueId
          stageName
          stageIsStarting
          stageIsEnding
          stageDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
        }
        serviceForm {
          id
          hasForm
          formType
        }
        serviceSentPopsmgg
        serviceIsRejected
      }
      officeBranches {
        ${branchOfficeFields}
      }
    }
  }
}
`

export const REMOVE_SERVICE_FROM_OFFICE_BRANCH_MUTATION = gql`
mutation RemoveServiceFromOfficeBranchMutation($input: ServiceOfficeBranchInputObject) {
  removeServiceFromOfficeBranchMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      service {
        id
        serviceUniqueId
        serviceIsSubService
        serviceName
        serviceIsApproved
        serviceDescription
        serviceHasSubService
        serviceHasCoProviders
        serviceCoProviders {
          ${serviceCoProviderFields}
        }
        serviceHasOpponents
        serviceGroups {
          id
          groupUniqueId
          groupType
        }
        serviceCategory {
          ${serviceCategoryFields}
        }
        serviceOpponents {
          id
          opponentUniqueId
          opponentInstitution {
            id
            institutionUniqueId
            institutionName
            institutionShortform
            institutionPhysicalAddress
            institutionEmail
            institutionPostcode
            institutionWebsite
            institutionPhones
            institutionMapUrl
            institutionLogo
          }
        }
        serviceResults {
          id
          resultUniqueId
          resultDescription
        }
        serviceProvider {
          id
          institutionUniqueId
          institutionName
          institutionShortform
          institutionPhysicalAddress
          institutionEmail
          institutionPostcode
          institutionWebsite
          institutionPhones
          institutionMapUrl
          institutionLogo
          institutionMinistry {
            id
            ministryUniqueId
            ministryName
          }
          institutionSector {
            id
            sectorUniqueId
            sectorName
            sectorIcon
          }
          institutionFunctions {
            id
            functionUniqueId
            functionDutyName
            functionCreateddate
            functionIsActive
          }
        }
        serviceApprovalStage {
          id
          stageUniqueId
          stageName
          stageIsStarting
          stageIsEnding
          stageDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
        }
        serviceForm {
          id
          hasForm
          formType
        }
        serviceSentPopsmgg
        serviceIsRejected
      }
      officeBranches {
        ${branchOfficeFields}
      }
    }
  }
}
`
